export const VIEW_IMAGE_TYPE = "image/webp";
export const VIEW_IMAGE_QUALITY = 0.9;
export const VIEW_IMAGE_MAX_DIMENSION = 2400;
